import React from "react";
import { Route, Redirect } from "react-router-dom";
import {BrowserUtility} from "../../utility/browser-utility";
const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        BrowserUtility.get('token')  ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default PrivateRoute;